import uuid from 'uuid';
import { isNil } from 'lodash';

import numbering from 'sharedParts/utils/numbering';

export default (index, labelText = 'Label') => ({
  id: uuid(),
  value: `${labelText} ${isNil(index) ? '' : numbering.toHuman(index)}`,
});
